// extracted by mini-css-extract-plugin
export default {"socials":"socials__socials___v6uY","social":"socials__social__wnUez","icon":"socials__icon__dePsY","navOpen":"socials__navOpen__hsqeN"};